/**
 * 간결한 로깅 유틸리티
 */
import { isAppDebugEnabled } from '@/utils/debug/debugEnv';

export class Logger {
  constructor(componentName = 'Unknown') {
    this.componentName = componentName;
  }

  /**
   * 간결한 시작 로그
   */
  start(action, data = null) {
    if (!isAppDebugEnabled()) return;

    const message = `[${this.componentName}] ${action} 시작`;
    if (data) {
      console.log(message, data);
    } else {
      console.log(message);
    }
  }

  /**
   * 간결한 완료 로그
   */
  complete(action, data = null) {
    if (!isAppDebugEnabled()) return;

    const message = `[${this.componentName}] ${action} 완료`;
    if (data) {
      console.log(message, data);
    } else {
      console.log(message);
    }
  }

  /**
   * 간결한 진행 로그
   */
  progress(action, current, total, data = null) {
    if (!isAppDebugEnabled()) return;

    const message = `[${this.componentName}] ${action} (${current}/${total})`;
    if (data) {
      console.log(message, data);
    } else {
      console.log(message);
    }
  }

  /**
   * 간결한 오류 로그
   */
  error(action, error, data = null) {
    const message = `[${this.componentName}] ${action} 오류`;
    if (data) {
      console.error(message, error, data);
    } else {
      console.error(message, error);
    }
  }

  /**
   * 간결한 경고 로그
   */
  warn(message, data = null) {
    if (!isAppDebugEnabled()) return;

    const fullMessage = `[${this.componentName}] ${message}`;
    if (data) {
      console.warn(fullMessage, data);
    } else {
      console.warn(fullMessage);
    }
  }

  /**
   * 간결한 정보 로그
   */
  info(message, data = null) {
    if (!isAppDebugEnabled()) return;

    const fullMessage = `[${this.componentName}] ${message}`;
    if (data) {
      console.log(fullMessage, data);
    } else {
      console.log(fullMessage);
    }
  }
}

/**
 * 간결한 로깅 함수들 (클래스 없이 사용)
 */
export const log = {
  start: (component, action, data = null) => {
    if (!isAppDebugEnabled()) return;
    const message = `[${component}] ${action} 시작`;
    data ? console.log(message, data) : console.log(message);
  },

  complete: (component, action, data = null) => {
    if (!isAppDebugEnabled()) return;
    const message = `[${component}] ${action} 완료`;
    data ? console.log(message, data) : console.log(message);
  },

  progress: (component, action, current, total, data = null) => {
    if (!isAppDebugEnabled()) return;
    const message = `[${component}] ${action} (${current}/${total})`;
    data ? console.log(message, data) : console.log(message);
  },

  error: (component, action, error, data = null) => {
    const message = `[${component}] ${action} 오류`;
    data ? console.error(message, error, data) : console.error(message, error);
  },

  warn: (component, message, data = null) => {
    if (!isAppDebugEnabled()) return;
    const fullMessage = `[${component}] ${message}`;
    data ? console.warn(fullMessage, data) : console.warn(fullMessage);
  },

  info: (component, message, data = null) => {
    if (!isAppDebugEnabled()) return;
    const fullMessage = `[${component}] ${message}`;
    data ? console.log(fullMessage, data) : console.log(fullMessage);
  }
};
